export const TRANSFORMATION_PROMPTS = {
 pixar: "Transform the photo into Pixar-style art",
 anime: "Transform the photo into anime style",
 cartoon: "Transform the photo into cartoon style art",
} as const;

export const TRANSFORMATION_THEMES = {
	anime: {
		primary: "indigo",
		secondary: "purple",
		accent: "indigo",
		gradient: {
			from: "from-indigo-500",
			to: "to-purple-600",
			hoverFrom: "hover:from-indigo-600",
			hoverTo: "hover:to-purple-700",
		},
		border: "border-indigo-200",
		hover: "hover:border-indigo-300",
		bg: "bg-indigo-50",
		hoverBg: "hover:bg-indigo-50",
		text: "text-indigo-600",
		hoverText: "hover:text-indigo-700",
		darkBg: "dark:bg-indigo-900/20",
		darkText: "dark:text-indigo-300",
		iconColor: "text-indigo-500",
		switchColor: "data-[state=checked]:bg-indigo-500",
		progressColor: "text-indigo-500",
	},
	pixar: {
		primary: "indigo",
		secondary: "purple",
		accent: "indigo",
		gradient: {
			from: "from-indigo-500",
			to: "to-purple-600",
			hoverFrom: "hover:from-indigo-600",
			hoverTo: "hover:to-purple-700",
		},
		border: "border-indigo-200",
		hover: "hover:border-indigo-300",
		bg: "bg-indigo-50",
		hoverBg: "hover:bg-indigo-50",
		text: "text-indigo-600",
		hoverText: "hover:text-indigo-700",
		darkBg: "dark:bg-indigo-900/20",
		darkText: "dark:text-indigo-300",
		iconColor: "text-indigo-500",
		switchColor: "data-[state=checked]:bg-indigo-500",
		progressColor: "text-indigo-500",
	},
	age: {
		primary: "indigo",
		secondary: "purple",
		accent: "indigo",
		gradient: {
			from: "from-indigo-500",
			to: "to-purple-600",
			hoverFrom: "hover:from-indigo-600",
			hoverTo: "hover:to-purple-700",
		},
		border: "border-indigo-200",
		hover: "hover:border-indigo-300",
		bg: "bg-indigo-50",
		hoverBg: "hover:bg-indigo-50",
		text: "text-indigo-600",
		hoverText: "hover:text-indigo-700",
		darkBg: "dark:bg-indigo-900/20",
		darkText: "dark:text-indigo-300",
		iconColor: "text-indigo-500",
		switchColor: "data-[state=checked]:bg-indigo-500",
		progressColor: "text-indigo-500",
	},
	cartoon: {
		primary: "indigo",
		secondary: "purple",
		accent: "indigo",
		gradient: {
			from: "from-indigo-500",
			to: "to-purple-600",
			hoverFrom: "hover:from-indigo-600",
			hoverTo: "hover:to-purple-700",
		},
		border: "border-indigo-200",
		hover: "hover:border-indigo-300",
		bg: "bg-indigo-50",
		hoverBg: "hover:bg-indigo-50",
		text: "text-indigo-600",
		hoverText: "hover:text-indigo-700",
		darkBg: "dark:bg-indigo-900/20",
		darkText: "dark:text-indigo-300",
		iconColor: "text-indigo-500",
		switchColor: "data-[state=checked]:bg-indigo-500",
		progressColor: "text-indigo-500",
	},
} as const;

export const ASPECT_RATIOS = [
	{ value: "match_input_image", label: "Original" },
	{ value: "3:2", label: "3:2" },
	{ value: "2:3", label: "2:3" },
	{ value: "1:1", label: "1:1" },
] as const;

export const DEFAULT_TRANSFORMATION_SETTINGS = {
	aspectRatio: "match_input_image",
	watermark: true,
	isPublic: false,
	customPrompt: "",
} as const;
